import { Locale } from 'modules/i18n';

export const checkoutPageContainerTranslation = {
  [Locale.en]: {
    cancel: 'Cancel',
    checkout: 'Checkout',
  },
};
